import * as t from './actionTypes';
import { UserType } from './types';
import { Action } from '../../common/types/types';

type State = {
  selectedItem: UserType | null;
  items: Array<UserType> | null;
  sortDesc: boolean;
  isDialogOpen: boolean;
};

export const initialState = {
  selectedItem: null,
  items: null,
  sortDesc: false,
  isDialogOpen: false,
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case t.SELECT_ITEM: {
      return {
        ...state,
        selectedItem: action.payload,
      };
    }
    case t.RETRIEVE_SUCCESS: {
      return {
        ...state,
        items: action.payload,
      };
    }
    case t.SORT: {
      return {
        ...state,
        sortDesc: !state.sortDesc,
      };
    }
    case t.TOGGLE_DIALOG: {
      return {
        ...state,
        isDialogOpen: action.payload,
      };
    }
    case t.RETRIEVE_START:
    case t.RETRIEVE_FAILURE:
    default:
      return state;
  }
};
